import React from 'react'
import { Clinic as ClinicType } from '@customTypes/Clinic'
import Spinner from '@components/Spinner'
import useStyles from './styles'
import Clinic from '@components/Clinic/Clinic'
import { Alert } from '@mui/material'

interface BodyProps {
  loading?: boolean
  clinic?: ClinicType
  ctaButton: React.ReactNode | null
  errorMessage?: string
}

const Body = ({ loading = false, clinic, children, ctaButton, errorMessage }: React.PropsWithChildren<BodyProps>) => {
  const classes = useStyles()

  if (loading) return <Spinner center size="large" />

  return (
    <div className={classes.root}>
      {children}
      {clinic && <Clinic clinic={clinic} />}
      {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
      <div className={classes.buttonContainer}>{ctaButton}</div>
    </div>
  )
}

export default Body
